export default __webpack_public_path__ + "static/Boy_01-a64b2bef4613c92389bdec378965274a.png";